import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '@/environments/environment';

@Component({
  selector: 'app-logo-box-2',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="logo-box-wrapper" [ngClass]="className">
      <a routerLink="/" class="logo-box-inner">
        <img
          [src]="getDarkLogo()"
          class="logo-img logo-dark"
          alt="Tenant Logo"
        />
        <img
          [src]="getLightLogo()"
          class="logo-img logo-light"
          alt="Tenant Logo"
        />
      </a>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .logo-box-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 70px;
      padding: 0 10px;
      box-sizing: border-box;
      transition: all 0.3s ease;
      overflow: hidden;
    }
    .logo-box-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      text-decoration: none;
    }
    .logo-img {
      max-width: 100%;
      max-height: 44px;
      width: auto;
      height: auto;
      object-fit: contain;
      display: block;
      transition: max-height 0.3s ease, max-width 0.3s ease;
    }

    /* Light/Dark mode toggling */
    .logo-dark {
      display: block;
    }
    .logo-light {
      display: none;
    }

    :host-context(html[data-bs-theme='dark']) .logo-dark,
    :host-context(html[data-menu-color='dark']) .logo-dark {
      display: none !important;
    }
    :host-context(html[data-bs-theme='dark']) .logo-light,
    :host-context(html[data-menu-color='dark']) .logo-light {
      display: block !important;
    }

    /* In Expanded / Full Sidebar */
    :host-context(.main-nav:hover) .logo-img,
    :host-context(html[data-menu-size='sm-hover-active']) .logo-img,
    :host-context(html[data-menu-size='default']) .logo-img {
      max-height: 44px;
      max-width: 175px;
    }

    /* In Collapsed Sidebar (when cursor is not on sidebar) */
    :host-context(html[data-menu-size='sm-hover'] .main-nav:not(:hover)) .logo-img,
    :host-context(html[data-menu-size='condensed']) .logo-img {
      max-width: 58px !important;
      max-height: 32px !important;
    }

    :host-context(html[data-menu-size='sm-hover'] .main-nav:not(:hover)) .logo-box-wrapper,
    :host-context(html[data-menu-size='condensed']) .logo-box-wrapper {
      padding: 0 4px !important;
    }

    /* Hover effect */
    .logo-box-wrapper:hover .logo-box-inner {
      transform: scale(1.03);
    }
  `]
})
export class LogoBox2Component {
  @Input() logoUrl: string = '';
  @Input() logoHeight: number | string = 44;
  @Input() className: string = '';
  isKrimans = environment.isKrimans;

  getDarkLogo(): string {
    if (this.isKrimans) {
      return 'assets/images/krigo_light_logo.png';
    }
    return (this.logoUrl && this.logoUrl.trim() !== '') ? this.logoUrl : 'assets/images/krigo_light_logo.png';
  }

  getLightLogo(): string {
    if (this.isKrimans) {
      return 'assets/images/krigo_dark_logo.png';
    }
    return (this.logoUrl && this.logoUrl.trim() !== '') ? this.logoUrl : 'assets/images/krigo_dark_logo.png';
  }
}
